import { useEffect, useRef, useState } from "react";

/**
 * Vídeo cabecera con 3 clips y crossfades ya renderizados en un único archivo.
 * Loop nativo del navegador. Se sirven ambos formatos (webm + mp4) para
 * máxima compatibilidad — el navegador elige el primero que sepa reproducir.
 */
export default function HeroVideos({ className = "" }) {
  const ref = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    v.muted = true;
    const p = v.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  }, []);

  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      <video
        ref={ref}
        muted
        loop
        autoPlay
        playsInline
        preload="auto"
        onCanPlay={() => setReady(true)}
        data-testid="hero-video"
        className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${
          ready ? "opacity-100" : "opacity-0"
        }`}
      >
        <source src="/videos/hero.webm" type="video/webm" />
        <source src="/videos/hero.mp4" type="video/mp4" />
      </video>
    </div>
  );
}
